var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 385 157",
    style: {
      enableBackground: "new 0 0 385 157"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#C398F2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    className: "st0",
    d: "M50.5,115.8v27.8h24.9V117c18.6-1.3,34.1-7.8,46-18.6c7.1,10,14.2,23.8,20.6,42.6l0,0 c0,0.1,0.1,0.2,0.1,0.4c0.1,0.4,0.2,0.9,0.3,1.4c0.1,0.5,0.1,0.7,0.1,0.7h26c0-2.3-0.6-5.2-0.8-6.2l0,0c-0.3-1.4-0.8-3.2-1.2-4.4 c-8.3-24.5-18.1-42.6-28.9-55.8c6.5-12.6,9.9-27.2,10.8-42.4c0.2-2.2,0.2-5.1,0.2-6.3v-0.1h-25.9c0,0.6,0,1.5,0,2.3 c0,0.4,0,0.8,0,1.1c0,0.2,0,0.3,0,0.4c0,0.1,0,0.1,0,0.1l0,0.3l0,0.3c-0.6,9.5-2.3,18.1-5,25.4c-0.5-0.4-1-0.7-1.5-1.1 C101.2,47.2,86.6,44.2,75.4,43V13.3H50.5V43c-5.6,0.9-11.1,2.6-16.1,5.2C24.2,53.6,16,63.5,16,77.8c0,11.9,4.4,22.9,14.9,30.2 C36.4,111.9,43,114.3,50.5,115.8z M75.4,91c12-1.1,21.1-5.3,28-11.2c-0.6-0.4-1.1-0.8-1.6-1.1c-9.1-6.1-18-8.5-26.4-9.6V91z  M50.5,69.5v19.6c-2.1-0.7-3.6-1.5-4.7-2.3c-2.4-1.7-3.9-4-3.9-9.1c0-2.8,1.1-4.8,4.7-6.7C47.7,70.5,49,69.9,50.5,69.5z M318.1,52.8 V28.5h-27.8v115h27.8V96.1c0-17.3,26.2-36.7,47.9-36.7h3V31.6h-3C347,31.6,326.7,38.8,318.1,52.8z M253.1,86 c0,17.2-14,31.2-31.2,31.2s-31.2-14-31.2-31.2s14-31.2,31.2-31.2S253.1,68.7,253.1,86z M279.7,86c0,31.9-25.9,57.8-57.8,57.8 s-57.8-25.9-57.8-57.8c0-31.9,25.9-57.8,57.8-57.8S279.7,54.1,279.7,86z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorLogo);
export default __webpack_public_path__ + "static/media/kor-logo.675412312937a2ee21c58a10a009cd6e.svg";
export { ForwardRef as ReactComponent };